const RecommendersInfo2Confirm = ({fields, viewMode, member}) => {

  return (
    <>
              <h3>推薦者 （代議員2名）</h3>
              <dl>
                <dt>推薦者１</dt>
          <dd>{(viewMode ? member.recommender1 : fields.recommender1) ? (viewMode ? member.recommender1 : fields.recommender1) : ''}&nbsp;</dd>
                <dt>推薦理由１</dt>
          <dd>{(viewMode ? member.reasonForRecommend1 : fields.reasonForRecommend1) ? (viewMode ? member.reasonForRecommend1 : fields.reasonForRecommend1) : ''}&nbsp;</dd>
                <dt>推薦者２</dt>
          <dd>{(viewMode ? member.recommender2 : fields.recommender2) ? (viewMode ? member.recommender2 : fields.recommender2) : ''}&nbsp;</dd>
                <dt>推薦理由２</dt>
          <dd>{(viewMode ? member.reasonForRecommend2 : fields.reasonForRecommend2) ? (viewMode ? member.reasonForRecommend2 : fields.reasonForRecommend2) : ''}&nbsp;</dd>
                </dl>
    </>
  );
}

export default RecommendersInfo2Confirm;
